import React, { memo, useEffect, useState } from 'react'
import { HeadingText, Avatar, Link, BodyText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import DsrBanner from '../common/dsr-banner'
import { fptiCustomSetup, fptiCustomClick } from '../../../utils'
import { ZETTLE_US_URL } from '../../../constants/constants'

const VerificationClosed = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.VERIFICATION_CLOSED_ERROR_IMPRESSION)
    }
  }, [])

  const bannerContent = {
    header: <Message id="dsrZettle.confirm.email.title" />,
    description: '',
  }

  const handleLinkClick = (event) => {
    event.preventDefault()
    fptiCustomClick(dsrFpti.VERIFICATION_CLOSED_NEWREQUEST_LINK)
    location.href = ZETTLE_US_URL
  }

  return (
    <>
      <DsrBanner {...bannerContent} />
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen">
            <div className="flex-center">
              <Avatar
                src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-critical.svg"
                className="focusedimg"
                alt="error"
              />
            </div>

            <HeadingText size="sm" className="text-center">
              <Message id="dsrZettle.verification.closed.body.description" />
            </HeadingText>

            <div className="margintop16">
              <BodyText className="text-center">
                <Message
                  id="dsrZettle.verification.closed.newrequest"
                  link={(innerMessage) => (
                    <Link href="/" onClick={handleLinkClick}>
                      {innerMessage}
                    </Link>
                  )}
                />
              </BodyText>
            </div>
          </section>
        </div>
      </section>
    </>
  )
})
VerificationClosed.displayName = 'VerificationClosed'

export default VerificationClosed
